export class DatasetVariable {
    constructor(
        public variableTypeId: number,
        public variableId: number,
        public studyAlias?: string
    ) {
    }
}

export class DatasetVariableOrder extends DatasetVariable {
    constructor(
        public variableTypeId: number,
        public variableId: number,
        public studyAlias?: string,
        public studyId?: number,
        public updateOrderToMoveUp?: boolean,
        public variableIdForSwitching?: number
    ) {
        super(variableTypeId, variableId, studyAlias);
    }
}

